import {
  Box,
  DarkTooltip,
  IconButton,
  Icons,
  Stack,
  styled,
} from "@/theme/index";
import { IconContainer } from "../index";

const InfoCard = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "4px",
  padding: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  justifyContent: "space-between",
}));

export interface ConnectionInfoCardProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  showCopyAction?: boolean;
  dataType?: string;
  copyValue?: string;
}

export function ConnectionInfoCard({
  icon,
  children,
  showCopyAction,
  dataType,
  copyValue,
}: ConnectionInfoCardProps) {
  function handleCopyClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();

    if (!copyValue) {
      return;
    }

    navigator.clipboard.writeText(copyValue || "");
  }

  return (
    <InfoCard>
      <Stack direction="row" gap={1} alignItems="center">
        {icon && <IconContainer icon={icon} />}
        {children}
      </Stack>
      {showCopyAction && (
        <DarkTooltip title={`Copy ${dataType}`} placement="bottom">
          <IconButton
            onClick={handleCopyClick}
            disableRipple
            disableFocusRipple
          >
            <Icons.ContentCopy
              fontSize="small"
              sx={{ ml: 1 }}
              color="secondary"
            />
          </IconButton>
        </DarkTooltip>
      )}
    </InfoCard>
  );
}
